import React from 'react';

const TransactionStatus = ({status}) => {

    let label = status ? 'Approved' : 'Rejected'    
    return ( 
        <div style={{
            display:'inline-block',
            borderRadius:40,
            border: `1px solid ${status ? '#a5d6a7' : '#ef5350'}`,   
            background: status ? '#e8f5e9' : '#ffcdd2' , 
            padding:'8px 16px' 
        }}>
            {label}
        </div>
     );
}
 
export default TransactionStatus;